export class MultiuploadDocuments {
    public categoryName: string;
    public documents: DocumentModel[];

    private showDocuments: boolean = true;

    constructor(categoryName: string, documents: DocumentModel[]) {
        this.categoryName = categoryName;
        this.documents = documents;
    }

    get getShowDocuments() {
        return this.showDocuments;
    }

    toggleDocuments(): void {
        this.showDocuments = !this.showDocuments;
    }
}

export class DocumentModel {
    public file: File;
    public internal: boolean;

    constructor(file: File, internal: boolean) {
        this.file = file;
        this.internal = internal;
    }
}
